'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initReviewContainers = undefined;

var _Helpers = require('scripts/common/Helpers');

var dom = {
  summaryContent: '[data-review-summary-content]',
  reviewsContainer: '[data-product-reviews]',
  reviewsSummary: '[data-product-review-summary]',
  reviewsListing: '[data-product-review-listing]',
  reviewWidget: '.stamped-main-widget',
  reviewInnerContainer: '.stamped-container',
  review: '.stamped-review',
  container: '[scroll-position="reviews"]'
};

var initSummaryBlocks = function initSummaryBlocks() {
  var $widget = $(dom.reviewWidget);
  var $summaryBlockList = $widget.find(dom.summaryContent);

  // Check if updated summary blocks already exist
  //  - prevents this from running again if widgets loads multiple times
  if ($summaryBlockList.length > 0) {
    return;
  }
  var $summary = $widget.find('.summary-overview');
  var $ratings = $widget.find('.stamped-summary-ratings');
  var $actions = $widget.find('.stamped-summary-actions');

  // Create new containers for each summary block
  var $summaryBlock = $('<div class="stamped-summary__content" data-review-summary-content></div>');
  var $ratingsBlock = $('<div class="stamped-summary__content" data-review-summary-content></div>');
  var $actionsBlock = $('<div class="stamped-summary__content" data-review-summary-content></div>');

  $summary.children().appendTo($summaryBlock);
  $ratings.children().appendTo($ratingsBlock);
  $actions.children().appendTo($actionsBlock);

  // Replace ratings text with stars
  $ratingsBlock.find('.summary-rating').each(function (idx, el) {
    var $rating = $(el);
    var rating = parseInt($rating.find('.summary-rating-bar').data('rating'));
    var count = $rating.data('count');

    if (!isNaN(rating)) {
      var ratingStars = [];
      for (var i = 1; i <= 5; i++) {
        if (i <= rating) {
          ratingStars.push('<i class="stamped-fa stamped-fa-star"></i>');
        } else {
          ratingStars.push('<i class="stamped-fa stamped-fa-star-o"></i>');
        }
      }

      var ratingContent = '<div class="summary-rating__content"><span class="summary-rating__stars">' + ratingStars.join('') + '</span><span class="summary-rating__count">(' + count + ')</span></div>';
      $rating.prepend(ratingContent);
    }
  });

  // Add titles to summary containers
  $summary.prepend('<span class="stamped-summary__title">' + $widget.data('summary-title') + '</span>').append($summaryBlock);
  $ratings.prepend('<span class="stamped-summary__title">' + $widget.data('average-title') + '</span>').append($ratingsBlock);
  $actions.prepend('<span class="stamped-summary__title">' + $widget.data('write-title') + '</span>').append($actionsBlock);
};

var initReviews = function initReviews() {
  var $widget = $(dom.reviewWidget);
  var reviewCount = $(dom.reviewInnerContainer).attr('data-count');
  $(dom.container).attr('data-count', reviewCount);

  $(dom.review).each(function (idx, review) {
    var $review = $(review);

    // Check if review has already been loaded
    //  - prevents this from running again when clicking "Load More"
    if ($review.attr('data-loaded')) {
      return;
    }

    var $stars = $review.find('.stamped-starratings');
    var $header = $review.find('.stamped-review-header');
    var $date = $header.find('.created');
    var $author = $header.find('.author');
    var $thumbsUp = $review.find('.stamped-thumbs-up');
    var $thumbsDown = $review.find('.stamped-thumbs-down');

    // Create header container for title and date
    // Iterate through all headers since review replies use the same classes as reviews
    $header.each(function (headerIdx, header) {
      var $indivHeader = $(header);
      var isReply = $indivHeader.closest('.stamped-review-reply').length;
      var $indivTitle = isReply ? $indivHeader.find('.stamped-review-header-title') : $indivHeader.siblings('.stamped-review-content').find('.stamped-review-body > .stamped-review-header-title');
      var $indivDate = $indivHeader.find('.created');
      var $headerTop = $('<div class="stamped-review-header__top"></div>');

      $headerTop.append($indivTitle).append($indivDate);
      $indivHeader.prepend($headerTop);
    });

    // Add verified buyer text to author
    $author.append('<span class="author-verified">Verified Buyer</span>');

    // Create left and right containers inside review
    var $reviewLeft = $('<div class="stamped-review__left" data-review-left>');
    var $reviewRight = $('<div class="stamped-review__right" data-review-right />');

    var $mobileDate = $date.eq(0).clone();
    $mobileDate.addClass('created--mobile');

    // Move stars and mobile date to left container
    $reviewLeft.append('<div class="stamped-review__rating" data-review-rating>' + $stars.data('rating').toFixed(1) + '</div>');
    $reviewLeft.append($stars).append($mobileDate);

    // Update thumbsup icons
    $thumbsUp.prepend('<img class="stamped-review__icon" src="' + $widget.data('thumbs-up') + '" alt="thumbs up" />');
    $thumbsDown.prepend('<img class="stamped-review__icon" src="' + $widget.data('thumbs-down') + '" alt="thumbs down" />');

    // Move review content to right container
    $reviewRight.append($review.html());

    $review.empty().append($reviewLeft).append($reviewRight).attr('data-loaded', true);
  });
};

// https://developers.stamped.io/?version=latest#7d02c323-794e-443f-9512-28373a244854
var initReviewContainers = exports.initReviewContainers = function initReviewContainers() {
  (0, _Helpers.addEventListenerStamped)(document, 'stamped:reviews:loaded', function (e) {
    initSummaryBlocks();
    initReviews();
  });
};